import { APIService } from "@/services/api";
import { ReadSurvey, WriteSurvey } from "@/types/survey";
import { API } from "@/lib/api";

const SurveyService = new APIService<ReadSurvey, WriteSurvey>(API.Surveys);

export const fetchSurveyList = SurveyService.getList;
export const fetchSurvey = SurveyService.get;
export const createSurvey = SurveyService.post;
export const updateSurvey = SurveyService.patch;
